import React, { useEffect, useState } from 'react'
import RpaClaimSubmitButton from '../../../../claimForm/submitClaim/RpaClaimSubmitButton'
import { connect, useDispatch } from 'react-redux'
import EyeMedStepForm from './EyeMedStepForm'
import { reduxForm } from 'redux-form'
import ScrollToTarget from '../../../../../../../../../itrust_common/components/others/ScrollToTarget'
import ClaimFormOverview from '../ClaimFormOverview'
import ClaimFormSync from '../../../../../../../../../components/authorised/order/edit/ClaimFormSync'
import Alert from '../../../../../../../../../itrust_common/components/Alert'
import { visionInsuranceClaimFormEdit, visionInsuranceClaimFormUpdate } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'
import DateFormatView from '../../../../../../../../../itrust_common/components/others/DateFormatView'
import { DIRECT_SAVE_CLAIM_OPTIONS, isDirectSaveClaimOrg } from '../../../../claimForm/directSaveClaimOrgHelper'
import { withOrdersInsuranceId } from '../../../../../../../../../components/authorised/order/claimFormDropdownUtils'
import { buildEyeMedLensesPayload, normalizeEyeMedLensesForForm } from './lenses/eyeMedLensesPayload'

function EyeMedClaimForm(props) {
  const { visionInsuranceConfig, order, handleSubmit, editing, visionInsuranceClaimForm, claimFormTemplate, organisation, eyemedAvailableLabs } = props
  const dispatch = useDispatch()
  const isDirectSaveOrg = isDirectSaveClaimOrg(organisation?.subdomain, order?.store_id)
  const firstStepActionLabel = isDirectSaveOrg ? 'Save' : 'Next'
  const [selectedLocation, setSelectedLocation] = useState(
    visionInsuranceClaimForm?.location || DIRECT_SAVE_CLAIM_OPTIONS[0].value
  )
  let filters = {}

  useEffect(() => {
    if (visionInsuranceClaimForm?.location) {
      setSelectedLocation(visionInsuranceClaimForm.location)
    }
  }, [visionInsuranceClaimForm?.location])

  useEffect(() => {
    if (isDirectSaveOrg) {
      dispatch(visionInsuranceClaimFormEdit({ formView: 'form' }))
      return
    }

    if (visionInsuranceClaimForm.billing?.claim_data?.charges?.length) {
      dispatch(visionInsuranceClaimFormEdit({ formView: 'overview' }))
    }
    else {
      dispatch(visionInsuranceClaimFormEdit({ formView: 'form' }))
    }
  }, [visionInsuranceClaimForm.billing?.claim_data?.charges, isDirectSaveOrg])

  const getActiveModuleArr = (res) => {
    return (res?.eligibility?.data || []).map(item => item.active && item.service_type ? item.service_type : '')
  }

  const getActiveModule = (res) => {
    const activeModulesArr = getActiveModuleArr(res)
    if (activeModulesArr.includes('Exam')) {
      return 'Exam'
    }
    else if (activeModulesArr.includes("Contact Lens Fit and Follow-up")) {
      return "Contact Lens Fit and Follow-up"
    }
    else if (activeModulesArr.includes("Frame")) {
      return "Frame"
    }
    else if (activeModulesArr.includes("Lenses")) {
      return "Lenses"
    }
  }

  const getActiveTabModule = (res) => {
    if (isDirectSaveOrg && editing.activeTab === 'first') return

    const { activeTab, activeModule } = editing;
    res = res ?? visionInsuranceClaimForm
    const activeModulesArr = getActiveModuleArr(res)
    switch (activeTab) {
      case 'first':
        dispatch(visionInsuranceClaimFormEdit({ activeTab: 2, activeModule: getActiveModule(res) }));
        break;
      case 2:
        if (activeModule === 'Exam') {
          if (res.exams.exam?.is_cpt2_selected == 'no') {
            if (activeModulesArr.includes("Contact Lens Fit and Follow-up")) {
              dispatch(visionInsuranceClaimFormEdit({ activeTab: 2, activeModule: 'Contact Lens Fit and Follow-up' }));
            }
            else if (activeModulesArr.includes("Frame")) {
              dispatch(visionInsuranceClaimFormEdit({ activeTab: 2, activeModule: 'Frame' }));
            }
            else if (activeModulesArr.includes("Lenses")) {
              dispatch(visionInsuranceClaimFormEdit({ activeTab: 2, activeModule: 'Lenses' }));
            }
            else {
              dispatch(visionInsuranceClaimFormEdit({ activeTab: 'final', activeModule: '' }));
            }
          }
          else {
            dispatch(visionInsuranceClaimFormEdit({ activeTab: 3, activeModule: 'Exam' }));
          }
        }
        else if (activeModule === 'Contact Lens Fit and Follow-up') {
          if (activeModulesArr.includes("Frame")) {
            dispatch(visionInsuranceClaimFormEdit({ activeTab: 2, activeModule: 'Frame' }));
          }
          else if (activeModulesArr.includes("Lenses")) {
            dispatch(visionInsuranceClaimFormEdit({ activeTab: 2, activeModule: 'Lenses' }));
          }
          else {
            dispatch(visionInsuranceClaimFormEdit({ activeTab: 'final', activeModule: '' }));
          }
        }
        else if (activeModule === 'Frame') {
          dispatch(visionInsuranceClaimFormEdit({ activeTab: 3, activeModule: 'Frame' }));
        }
        else if (activeModule === 'Lenses') {
          dispatch(visionInsuranceClaimFormEdit({ activeTab: 'final', activeModule: '' }));
        }
        break;
      case 3:
        if (activeModule === 'Exam') {
          if (activeModulesArr.includes("Contact Lens Fit and Follow-up")) {
            dispatch(visionInsuranceClaimFormEdit({ activeTab: 2, activeModule: 'Contact Lens Fit and Follow-up' }));
          }
          else if (activeModulesArr.includes("Frame")) {
            dispatch(visionInsuranceClaimFormEdit({ activeTab: 2, activeModule: 'Frame' }));
          }
          else if (activeModulesArr.includes("Lenses")) {
            dispatch(visionInsuranceClaimFormEdit({ activeTab: 2, activeModule: 'Lenses' }));
          }
          else {
            dispatch(visionInsuranceClaimFormEdit({ activeTab: 'final', activeModule: '' }));
          }
        }
        else if (activeModule === 'Frame') {
          if (activeModulesArr.includes("Lenses")) {
            dispatch(visionInsuranceClaimFormEdit({ activeTab: 2, activeModule: 'Lenses' }));
          }
          else {
            dispatch(visionInsuranceClaimFormEdit({ activeTab: 'final', activeModule: '' }));
          }
        }
        break;
      case 'final':
        dispatch(visionInsuranceClaimFormEdit({ activeTab: '', activeModule: '' }));
        dispatch(visionInsuranceClaimFormEdit({ formView: 'overview' }))
        break;
      default:
        break;
    }
  };

  const computeData = (data) => {
    const filterActive = (items) => Array.isArray(items) ? items.filter(item => item.active) : items;
    const { exams } = data;
    if (exams) {
      //  filter each exam field is checked
      exams.exam && Object.keys(exams.exam).forEach(field => {
        if (exams.exam[field]) {
          exams.exam[field] = filterActive(exams.exam[field]);
        }
      });
      // filter each impression field is checked
      exams.impression && Object.keys(exams.impression).forEach(field => {
        if (exams.impression[field]) {
          exams.impression[field]['selected_value'] = filterActive(exams.impression[field]['selected_value']);
          exams.impression[field]['cpt_codes'] = filterActive(exams.impression[field]['cpt_codes']);
        }
      });
    }
    const { lenses: _unusedLenses, ...rest } = data
    return {
      ...rest,
      exams: data.exams || { exam: {}, impression: {} },
      contact_lens_fit_and_follow_up: data.contact_lens_fit_and_follow_up || {},
      frames: data.frames || {},
      claim_data: {
        ...(data.claim_data || {}),
        lenses: buildEyeMedLensesPayload({
          ...(data.lenses || {}),
          laboratory: eyemedAvailableLabs[0] || data.lenses?.laboratory,
        }),
      },
    };
  };

  const validateFormData = (data) => {
    const isAnyModuleSelected = data.eligibility?.data.find(item => item.active)
    // validate final step billing amount
    let chargesValidateArr = data.claim_data?.charges?.map(item => Number(item.charge))
    const hasNaN = chargesValidateArr ? (chargesValidateArr.find(item => Number.isNaN(item)) !== undefined) : false
    if (!isAnyModuleSelected) {
      Alert.warning('Please select a service to proceed.')
      return false
    }
    if (hasNaN) {
      Alert.warning('Invalid Amount')
      return false
    }
    return true
  }

  const getFilters = (data) => {
    const { activeTab, activeModule } = editing;
    const activeModulesArr = getActiveModuleArr(data)
    switch (activeTab) {
      case 'first':
        return { claim_sections: ['eligibility'] }
      case 'final':
        return { claim_sections: ['charges'] }
      case 2:
        if (activeModule === 'Exam') {
          if (data.exams?.exam?.is_cpt2_selected === 'no' && !activeModulesArr.includes("Contact Lens Fit and Follow-up") && !activeModulesArr.includes("Frame") && !activeModulesArr.includes("Lenses")) {
            return { claim_sections: ['exams', 'billing'] }
          }
          else {
            return { claim_sections: ['exams'] }
          }
        } else if (activeModule === 'Contact Lens Fit and Follow-up') {
          if (activeModulesArr.includes("Frame") || activeModulesArr.includes("Lenses")) {
            return { claim_sections: ['contact_lens_fit_and_follow_up'] }
          }
          return { claim_sections: ['contact_lens_fit_and_follow_up', 'billing'] }
        } else if (activeModule === 'Frame') {
          // Frame step 1: persist manufacturer selections only
          return {}
        } else if (activeModule === 'Lenses') {
          return { claim_sections: ['billing'] }
        }
        break;
      case 3:
        if (activeModule === 'Exam') {
          if (activeModulesArr.includes("Contact Lens Fit and Follow-up") || activeModulesArr.includes("Frame") || activeModulesArr.includes("Lenses")) {
            return { claim_sections: ['impression'] }
          }
          else {
            return { claim_sections: ['impression', 'billing'] }
          }
        } else if (activeModule === 'Frame') {
          // Frame step 2: save attestation fields and build billing/charges for final step
          return { claim_sections: ['billing'] }
        }
        break;
      default:
        return {}
    }
    return {}
  }

  const handleClaimFormUpdate = async (data, mediaOnly) => {
    data = computeData(data)
    const isFormValid = validateFormData(data)
    filters = getFilters(data) || {}
    if (isFormValid) {
      const payload = isDirectSaveOrg ? { ...data, location: selectedLocation } : data
      const res = await dispatch(visionInsuranceClaimFormUpdate(
        payload,
        withOrdersInsuranceId({ ...filters, include: '*' }, editing.orders_insurance_id),
      ))
      const log = res.value.data.insurance_claim_form
      getActiveTabModule({ ...log, id: res.value.data.id || log?.id || data.id })
      filters = {}
    }
    return
  }

  const handleSyncSuccessfully = () => {
    dispatch(visionInsuranceClaimFormEdit({ activeTab: 'first', activeModule: '', formView: 'form' }));
  }

  const orderInsurance = order.orders_insurances_attributes?.find(
    (item) => item.id === editing?.orders_insurance_id,
  )
  const claimSubmissionAt = orderInsurance?.claim_submission_at || order.claim_submission_at

  return (
    <div className='px-6'>
      {order.insurance_payer_changed && <h5 className='text-danger mb-5 text-center'>The insurance payer name is changed for the selected insurance.</h5>}
      <div className='d-flex justify-content-between align-items-center'>
        <div>
          {visionInsuranceConfig?.visible && <RpaClaimSubmitButton order={order} />}
          {!isDirectSaveOrg && editing.formView !== 'overview' &&
            <button className='btn btn-outline-primary' onClick={() => dispatch(visionInsuranceClaimFormEdit({ formView: 'overview' }))}>Overview</button>
          }
          {claimSubmissionAt && <span className='text-danger ml-6'>Previous Claim Send on <DateFormatView dateTime={claimSubmissionAt} />
          </span>}
        </div>
        <div className='d-flex align-items-center'>
          {isDirectSaveOrg ? (
            <div className="form-group mb-0 ml-md-5">
              <label className="mb-1" htmlFor="direct-save-claim-location">Location:</label>
              <select
                id="direct-save-claim-location"
                className="form-control"
                style={{ minWidth: '180px' }}
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
              >
                {DIRECT_SAVE_CLAIM_OPTIONS.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <ClaimFormSync label="Reset" handleAfterSyncSuccessfully={handleSyncSuccessfully} />
          )}
        </div>
      </div>
      {editing.formView == 'overview' ?
        <ClaimFormOverview visionInsuranceClaimForm={visionInsuranceClaimForm} claimFormTemplate={claimFormTemplate} eyemedAvailableLabs={eyemedAvailableLabs} /> :
        <form onSubmit={handleSubmit(handleClaimFormUpdate)}>
          <EyeMedStepForm pprops={{ ...props, firstStepActionLabel, submitEyeMedClaimForm: () => handleSubmit(handleClaimFormUpdate)(true) }} />
        </form>
      }
    </div>
  )
}

EyeMedClaimForm = reduxForm({
  form: 'EyeMedClaimForm',
  enableReinitialize: true,
  shouldValidate: () => true,
  onSubmitFail: () => ScrollToTarget()
})(EyeMedClaimForm)

const mapStateToProps = (state) => {
  const { organisation: { organisation }, order: { order }, visionInsuranceClaimForm: { visionInsuranceClaimForm, saving, editing, eyemedAvailableLabs = [] } } = state

  return {
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance,
    organisation,
    order,
    visionInsuranceClaimForm,
    eyemedAvailableLabs,
    editing,
    saving,
    initialValues: {
      ...visionInsuranceClaimForm,
      lenses: normalizeEyeMedLensesForForm(
        visionInsuranceClaimForm?.claim_data?.lenses || visionInsuranceClaimForm?.lenses || {},
        eyemedAvailableLabs,
      ),
    }
  }
}

export default connect(mapStateToProps)(EyeMedClaimForm)